// Scroll animations
document.addEventListener("DOMContentLoaded", function () {
  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -100px 0px",
  };

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
      }
    });
  }, observerOptions);

  // Observe all elements with fade class
  document.querySelectorAll(".fade").forEach((el) => {
    observer.observe(el);
  });

  // Add smooth scrolling for anchor links
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute("href"));
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });

  // Add some interactive particle effects on mouse move
  let mouseX = 0;
  let mouseY = 0;

  document.addEventListener("mousemove", (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  // Create floating particles
  function createParticle() {
    const particle = document.createElement("div");
    particle.className = "particle";
    particle.style.cssText = `
      position: fixed;
      width: 4px;
      height: 4px;
      background: radial-gradient(circle, rgba(147, 51, 234, 0.8) 0%, transparent 70%);
      border-radius: 50%;
      pointer-events: none;
      z-index: 1000;
      animation: float-particle 3s ease-out forwards;
    `;

    particle.style.left = mouseX + "px";
    particle.style.top = mouseY + "px";

    document.body.appendChild(particle);

    setTimeout(() => {
      particle.remove();
    }, 3000);
  }

  // Add particle CSS animation
  const style = document.createElement("style");
  style.textContent = `
    @keyframes float-particle {
      0% {
        transform: translateY(0px) scale(1);
        opacity: 1;
      }
      100% {
        transform: translateY(-100px) scale(0);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);

  // Create particles on mouse move (throttled)
  let particleThrottle = false;
  document.addEventListener("mousemove", () => {
    if (!particleThrottle) {
      createParticle();
      particleThrottle = true;
      setTimeout(() => {
        particleThrottle = false;
      }, 100);
    }
  });
});
